import { Injectable, signal } from '@angular/core';
import { Lang, t } from '../i18n/translations';

/**
 * Minimal language service — signal-driven, no @ngx-translate dependency.
 * The payment kiosk only supports de + en; the default comes from station-config.
 */
@Injectable({ providedIn: 'root' })
export class LanguageService {
    readonly lang = signal<Lang>('de');

    /** Translate a key into the current language. */
    t(key: string): string {
        return t(this.lang(), key);
    }

    set(lang: Lang): void {
        this.lang.set(lang);
    }

    /**
     * Adopt the browser's own language — **only** for surfaces running on the parker's device.
     *
     * The column must NOT call this: it is a fixed installation whose default belongs to the station
     * config, and it would otherwise re-language itself for whatever browser happens to be driving it.
     * The settlement page is the opposite case — reached by QR from a phone, with no `?lang=` to go on,
     * it defaulted every parker to German no matter where they were from.
     *
     * German stays the fallback rather than English: the sites are Austrian, so a visitor whose
     * language we do not support is likelier served by German than by English.
     */
    setFromBrowser(): void {
        const tag = (globalThis.navigator?.language ?? '').toLowerCase();
        this.lang.set(tag.startsWith('en') ? 'en' : 'de');
    }
}
